"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShimmeredDetailsList = void 0;
var Utilities_1 = require("../../Utilities");
var ShimmeredDetailsList_base_1 = require("./ShimmeredDetailsList.base");
var ShimmeredDetailsList_styles_1 = require("./ShimmeredDetailsList.styles");
exports.ShimmeredDetailsList = (0, Utilities_1.styled)(ShimmeredDetailsList_base_1.ShimmeredDetailsListBase, ShimmeredDetailsList_styles_1.getShimmeredDetailsListStyles, undefined, { scope: 'ShimmeredDetailsList' });
//# sourceMappingURL=ShimmeredDetailsList.js.map